import { render } from "./AboutPage.vue?vue&type=template&id=bb5b65ee&scoped=true"
const script = {}

import "./AboutPage.vue?vue&type=style&index=0&id=bb5b65ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb5b65ee"]])

export default __exports__